export const getButtonText = data => {
  if (data?.status === 'ALLOW') {
    return 'Активировать';
  }

  return 'Подробнее';
};
